import { FaHeart } from 'react-icons/fa'

import FooterSiteLinks from './FooterSiteLinks'
import FooterAgencies  from './FooterAgencies'

import Image from '../Pure/Image'


const img_config =
{
	original: 1000,
	desktop: 1000,

	available: [500, 1000, 1500, 2000, 3000]
};

/**
 *
 * @param { Object } props
 *
 * @returns { React.ReactElement }
**/
export default function FrontFooter (props)
{
	const logo_src = '/images/logo_fond_noir.png';

	const logo_alt_suffix = 'Pompes Funèbres';

	return (
		<footer className="c-footer">

			<FooterAgencies />

			<div className="c-footer__items">
				<div className="c-footer__items--legal">
					<Image src={ logo_src } alt={ 'logo Sotraf ' + logo_alt_suffix } src_config={ img_config }
				/>
					<p className="u-italic">
						Les pompes-funèbres, bien plus qu'un simple métier, bien plus qu'un simple Hommage.
					</p>
				</div>

				<FooterSiteLinks layout={ props.layout } />

			</div>

			<div className="c-footer__bottom">
				<p>Sotraf © 2026 - Fait avec&nbsp;</p>
				<FaHeart title="coeur" />
				<p>&nbsp;par Panda One</p>
			</div>

		</footer>
	);
}